import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "context/authContext";

export default function RequireAuth({ children }) {
  const { isAuthenticated } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return children;
}
